import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const ClearIndicator = ({ innerProps }) => {
  const theme = useTheme();

  return (
    <IconButton
      aria-label="Clear AutoComplete"
      edge="end"
      {...innerProps}
      size="large"
      data-testid="clearOption"
    >
      <CloseIcon fontSize="small" style={{ color: theme.palette.grey[600] }} />
    </IconButton>
  );
};

ClearIndicator.propTypes = {
  innerProps: PropTypes.object,
};

export default ClearIndicator;
